module.exports = __webpack_public_path__ + "img/RASP_logo.08e5eefa.png";